import React from 'react';
import { Tooltip, Typography } from '@mui/material';

const DownloadButton = ({ fileUrl, fileName }) => {
  return (
    <Tooltip title={fileName} arrow>
      <Typography
        component='a'
        href={fileUrl}
        download={fileName}
        target='_blank'
        sx={{
          textDecoration: 'none',
          color: 'primary.main',
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          maxWidth: 150,
          '&:hover': {
            textDecoration: 'underline',
          },
        }}
      >
        {fileName}
      </Typography>
    </Tooltip>
  );
};

export default DownloadButton;
